/**
 * @file MessageBs_mcp.tsx
 * @description 展示 MCP Server 命中信息：折叠面板显示各 Server 的命中工具统计与名称。
 */
import McpStar from '@/assets/mcp/mcp-star.svg'
import { Collapse } from 'antd'
import type { FC, ReactNode } from 'react'
import { memo } from 'react'

/**
 * 组件 Props
 * @property list 列表来源（list[0].title 为 JSON 字符串，包含服务与工具命中信息）
 * @property showMcpOutput 是否显示工具输出（当前预留，未启用）
 */
interface IProps {
  children?: ReactNode
  list: any
  showMcpOutput: boolean
}

const MessageBs_mcp: FC<IProps> = ({ list, showMcpOutput = false }) => {
  const mcp_list = JSON.parse(list[0]?.title)

  return (
    <div className="MessageBs_mcp">
      <Collapse
        bordered={false}
        defaultActiveKey={['1']}
        style={{ background: '#f9f9fe' }}
        expandIconPosition="end"
        items={[
          {
            key: '1',
            label: (
              <div className="MessageBs_mcp_header">
                <img src={McpStar} alt="" />
                <div> 已调用MCP Server</div>
              </div>
            ),
            children: (
              <div className="MessageBs_mcp_body">
                {mcp_list.map(item => (
                  <div className="item" key={item.server_name}>
                    <div className="title">
                      {item.server_name}（命中 {item.hit_count}/{item.total_count} 个工具）
                    </div>
                    {item.hit_info.map(it => (
                      <div className="text" key={it.tool_name}>
                        <div>{it.tool_name}</div>
                        {/* {
                              showMcpOutput && (
                                <div >
                                  {it.tool_content}
                                </div>
                              )
                            } */}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )
          }
        ]}
      />
    </div>
  )
}

export default memo(MessageBs_mcp)
